import { RenderJob } from "@/lib/user-types";
import { RenderStatusBadge } from "@/components/render-status-badge";
import { Link } from "wouter";
import { FilmIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { formatDistanceToNow } from "date-fns";

interface RenderCardProps {
  renderJob: RenderJob;
}

export function RenderCard({ renderJob }: RenderCardProps) {
  const getStatusInfo = () => {
    if (renderJob.status === 'complete' && renderJob.completedAt) {
      return formatDistanceToNow(new Date(renderJob.completedAt), { addSuffix: true });
    }
    
    if (renderJob.status === 'rendering' && renderJob.estimatedCompletionTime) {
      return `Est. completion: ${formatDistanceToNow(
        new Date(renderJob.estimatedCompletionTime), 
        { addSuffix: false }
      )}`;
    }
    
    return '';
  };
  
  const getIconColor = () => {
    switch (renderJob.status) {
      case 'complete':
        return 'bg-green-100 text-green-600';
      case 'rendering':
      case 'queued':
        return 'bg-yellow-100 text-yellow-600';
      case 'failed':
        return 'bg-red-100 text-red-600';
      default:
        return 'bg-primary-100 text-primary-600';
    }
  };
  
  return (
    <li className="py-4">
      <div className="flex items-center space-x-4">
        <div className="flex-shrink-0">
          <div className={cn("h-10 w-10 rounded-full flex items-center justify-center", getIconColor())}>
            <FilmIcon className="h-5 w-5" />
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-gray-900 truncate">
            {renderJob.title} - {renderJob.style}
          </p>
          <div className="flex items-center">
            <RenderStatusBadge status={renderJob.status} />
            {getStatusInfo() && (
              <span className="text-sm text-gray-500 ml-2">
                {getStatusInfo()}
              </span>
            )}
          </div>
        </div>
        <div>
          <Link href={`/renders/${renderJob.id}`}>
            <a className="inline-flex items-center shadow-sm px-2.5 py-0.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50">
              View
            </a>
          </Link>
        </div>
      </div>
    </li>
  );
}
